if (!customElements.get("footer-details")) {
  class FooterDetails extends AccordionDetails {
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.openDefault = this.dataset.openDefault === 'true';

      // Footer-scoped breakpoint aligned to layout wrap (768px)
      this._mq = window.matchMedia('(max-width: 767px)');
      this._onMQChange = (e) => this._applyMode(e.matches);
      
      // Add listener (support both modern and legacy methods)
      if (this._mq.addEventListener) {
        this._mq.addEventListener('change', this._onMQChange);
      } else {
        this._mq.addListener(this._onMQChange);
      }

      // Apply initial mode
      this._applyMode(this._mq.matches);
    }

    disconnectedCallback() {
      if (this._mq) {
        if (this._mq.removeEventListener) {
          this._mq.removeEventListener('change', this._onMQChange);
        } else {
          this._mq.removeListener(this._onMQChange);
        }
      }
    }

    _applyMode(isMobile) {
      if (isMobile) {
        // Mobile (stacked): enable accordion, honor data-open-default
        this.open = this.openDefault;
      } else {
        // Tablet/Desktop (two-column): force open and disable toggle
        this.open = true;
      }
    }
  }
  customElements.define('footer-details', FooterDetails, { extends: 'details' });
}